import React, {Component} from 'react';

class ToggleButton extends Component {
  toggle() {
    this.props.onClick(this.props, !this.props.on);
  }

  render() {
    return (
      <div
        onClick={this.toggle.bind(this)}
        className={`button ${this.props.on ? 'inverted' : ''}`}>{this.props.text}</div>
    );
  }
}

class InlineExpandable extends Component {
  static defaultProps = {
    numVisible: 5,
    showMorePosition: 'top'
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  render() {
    let showMore = (
      !this.state.expanded && this.props.children.length > this.props.numVisible &&
      <div className='align-right pointer show-more' onClick={() => this.setState({expanded: true})}>Show All</div>);

    return (
      <div className={this.props.className}>
        <div className='flex flex-align-bottom'>
          <h1>{this.props.text}</h1>
          {this.props.showMorePosition === 'top' ? showMore : ''}
        </div>
        <ul className='inline-list'>
            {React.Children.map(this.props.children, (child, i) => {
              let display = 'none';
              if (this.state.expanded || i < this.props.numVisible) {
                display = 'inline-block';
              }
              return <li key={i} style={{display: display}}>{child}</li>;
            })}
        </ul>
        {this.props.showMorePosition === 'bottom' ? showMore : ''}
      </div>
    );
  }
}


class Input extends Component {
  render() {
    return (
      <div>
        <input {...this.props}/>
        {this.props.error &&
          <div className='form-field-error'>{this.props.error}</div>}
      </div>
    );
  }
}


class TextArea extends Component {
  onChange(ev) {
    this.props.onChange(ev);
  }

  render() {
    return (
      <div>
        <div className='relative'>
          <textarea name={this.props.name} maxLength={this.props.maxLength} placeholder={this.props.placeholder} onChange={this.onChange.bind(this)} value={this.props.value} />
          <div className='textarea-counter'>{this.props.value.length}/{this.props.maxLength}</div>
        </div>
        {this.props.error &&
          <div className='form-field-error'>{this.props.error}</div>}
      </div>
    )
  }
}

class YearInput extends Component {
  onChange(ev) {
    // rough heuristic for validating a year
    if (/^(\d){1,4}$/.test(ev.target.value)) {
      this.props.onChange(ev);
    }
  }

  render() {
    return (
      <Input type='text' value={this.props.value} name={this.props.name} placeholder={this.props.placeholder} onChange={this.onChange.bind(this)} error={this.props.error}/>
    )
  }
}

export {Input, TextArea, YearInput, ToggleButton, InlineExpandable};



// WEBPACK FOOTER //
// ./res/front/static/js/form.js